const Documentation = require('./Documentation');

module.exports = Documentation;
